<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fpiCdJ/tc-custom/9780830871490.jpg?1696363259843" alt="This image is the cover for the book Serving God in Today's Cities, Operation World Resources"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Serving God in Today's Cities, Operation World Resources
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>Welcome to the world's first urban century. How will you respond?</strong> For the first time ever, more people now live in cities than outside them. Cities offer both big headaches and vast opportunities, and agencies that once focused on rural work are increasingly turning their attention to urban centers. Join veteran researcher and missiologist Patrick Johnstone as he explores the fastest growing cities and megacities in the world, showing how Christian workers are addressing people's spiritual, physical, and social needs. In 1962 Patrick Johnstone left England's countryside to serve the bustling townships of apartheid-era South Africa. His pioneering of urban ministries changed his life. Journey with Patrick and Dean Merrill as they share God's heart for the city and introduce pastors, missionaries, and community workers who are addressing urbanization's key challenges. God has a heart for today's cities. See how you can join this urgent mission.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patrick Johnstone, Dean Merrill, Ed Stetzer
      </h2>
      
      <p class="authorDescription body article"><p>Patrick Johnstone has informed and inspired a generation of Christian workers with his <em>Operation World</em> books, which have sold 2.5 million copies. He lives in Cambridgeshire, England, where he serves as a regional director for WEC International's European bases. His most recent book is <em>The Future of the Global Church.</em> </p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Christian
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5a7c8b14